export default function loadFromLocalStorage<T>(token: string, defaultValue: T = undefined): T {
    const json = localStorage.getItem(token);
    if(json === null || json === undefined || json === 'undefined'){
        return defaultValue;
    }

    try {
        return JSON.parse(json);
    }
    catch (e){
        return defaultValue
    }
}
